import type { Template } from '@/config/objects/templates';
import { useOutletContext } from 'react-router-dom';

interface TemplateContext {
  template: Template | undefined;
  isLoading: boolean;
}

export function useTemplateContext() {
  return useOutletContext<TemplateContext>();
}
